import * as React from 'react';
import styled from 'styled-components';
import Field from '../../Field/Field';
import NewInput from '../../NewInput/NewInput';

import { FilterComponentProps } from '../types';

type CashValueFilterType = {
  /* The specific amount to filter by (equals) */
  equal?: string;
  /* The minimum amount to filter by (greater than) */
  greaterThan?: string;
  /* The maximum amount to filter by (less than) */
  lessThan?: string;
};

const CharacterIcon = styled.span`
  font-size: 18px;
  line-height: 16px;
  font-weight: 200;
`;

export interface CashValueFilterProps<T extends CashValueFilterType> extends FilterComponentProps<T> {}

export const CashValueFilter = <T extends CashValueFilterType>({ value, setValue }: FilterComponentProps<T>) => (
  <>
    <Field isStacked label="Specific amount">
      <NewInput
        id="filter-eq"
        name="filter-eq"
        value={value.equal}
        disabled={Boolean(value.greaterThan || value.lessThan)}
        onChange={e => setValue({ ...value, equal: e.target.value })}
        mask="decimal"
        prefix={<CharacterIcon>=</CharacterIcon>}
        width="full"
      />
    </Field>
    <Field isStacked label="At least...">
      <NewInput
        id="filter-gt"
        name="filter-gt"
        value={value.greaterThan}
        disabled={Boolean(value.equal || value.lessThan)}
        onChange={e => setValue({ ...value, greaterThan: e.target.value })}
        mask="decimal"
        prefix={<CharacterIcon>≥</CharacterIcon>}
        width="full"
      />
    </Field>
    <Field isStacked label="No more than...">
      <NewInput
        id="filter-lt"
        name="filter-lt"
        value={value.lessThan}
        disabled={Boolean(value.equal || value.greaterThan)}
        onChange={e => setValue({ ...value, lessThan: e.target.value })}
        mask="decimal"
        prefix={<CharacterIcon>≤</CharacterIcon>}
        width="full"
      />
    </Field>
  </>
);

CashValueFilter.label = ({ equal = '', greaterThan = '', lessThan = '' }) => {
  if (equal) {
    return `Amount: ${equal}`;
  }
  if (greaterThan) {
    return `At least ${greaterThan}`;
  }
  if (lessThan) {
    return `Under ${lessThan}`;
  }
  return undefined;
};
